<template>
  <div>
    <header>
      项目名称：
      <el-input
        v-model="searchKey"
        placeholder="请输入单位名称"
        style="width: 340px"
      ></el-input>
      状态：
      <el-select
        v-model="status"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          :value="-1"
        > </el-option>
        <el-option
          label="有效"
          :value="1"
        > </el-option>
        <el-option
          label="无效"
          :value="2"
        > </el-option>
      </el-select>
      项目类型：
      <el-select
        v-model="projectTyle"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          :value="-1"
        > </el-option>
        <el-option
          :label="item.typeName"
          :value="item.id"
          v-for="item in projectTypeList"
          :key="item.id"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="getList"
      >查询</el-button>
      <el-button
        type="primary"
        @click="openAdd"
      >新增</el-button>
    </header>
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        type="index"
        label="序号"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="projectName"
        label="项目名称"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="belongUnitName"
        label="公司名称"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="authorityProjectTypeName"
        label="项目类型"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="projectLeader"
        label="项目用户"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="授权模块"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="getModules(scope.row)"
          >授权模块</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.status == 1 ? '有效' : '无效' }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="del(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top: 20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="editId ? '编辑' : '新增'"
      :visible.sync="addDialogVisible"
      width="1300px"
      center
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        ref="ruleForm"
        :model="form"
        label-width="160px"
        :rules="rules"
      >

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="项目名称:"
              prop="projectName"
            >
              <el-input v-model="form.projectName"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="项目所在地:"
              prop="address"
            >
              <el-cascader
                size="large"
                :options="options"
                :key="modalKey"
                v-model="form.selectedOptions"
              >
              </el-cascader>
              <el-input
                style="width: 222px; margin-left: 10px"
                v-model="form.address"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="项目类型:"
              prop="authorityProjectTypeId"
            >
              <el-select
                v-model="form.authorityProjectTypeId"
                placeholder="请选择"
              >
                <el-option
                  :label="item.typeName"
                  :value="item.id"
                  v-for="item in projectTypeList"
                  :key="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="项目规模:"
              prop="projectArea"
            >
              <el-input
                v-model="form.projectArea"
                type="number"
                onkeyup="value=value.replace(/[^0-9]/g,'');if(value>100){value=100};if(String(value)==='0'){value=1}"
                placeholder="最大数量100"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="所属单位名称:"
              prop="belongUnitName"
            >
              <el-input
                v-model="form.belongUnitName"
                disabled
              ></el-input>
              <!-- <el-select
                v-model="form.belongUnitName"
                placeholder="请选择"
              >
                <el-option
                  :label="item.companyName"
                  :value="item.companyName"
                  v-for="item in belongUnitList"
                  :key="item.id"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="所属单位类型:"
              prop="authorityUnitTypeId"
            >
              <el-select
                v-model="form.authorityUnitTypeId"
                placeholder="请选择"
              >
                <el-option
                  :label="item.typeName"
                  :value="item.id"
                  v-for="item in unitTypeList"
                  :key="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="统一社会信用代码:"
              prop="unitCode"
            >
              <el-input v-model="form.unitCode"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="施工许可证号:"
              prop="permitCode"
            >
              <el-input v-model="form.permitCode"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="账号:"
              prop="userAccount"
            >
              <el-input v-model="form.userAccount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="密码:"
              prop="userPwd"
            >
              <el-input
                v-model="form.userPwd"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="项目负责人:">
              <el-input v-model="form.projectLeader"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="项目负责人电话:">
              <el-input v-model="form.projectLeaderPhone"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="有效状态:"
              prop="status"
            >
              <el-radio
                v-model="form.status"
                :label="1"
              >有效</el-radio>
              <el-radio
                v-model="form.status"
                :label="2"
              >无效</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="菜单配置:"
              prop="templateId"
            >
              <el-select
                @change="handleChangeProvince"
                v-model="form.templateProvinceId"
                filterable
                placeholder="请输入省份名称查询"
              >
                <el-option
                  v-for="item in [{ value: '-1', label: '全国' }, ...options]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="form.templateId"
                placeholder="请选择"
                style="margin-left: 10px;width: 222px;"
              >
                <el-option
                  v-for="op in ProvinceMenusOption"
                  :key="op.item1"
                  :label="op.item2"
                  :value="op.item1"
                >
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="手机号码:"
              prop="telephone"
            >
              <el-input v-model="form.telephone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >确定</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- resetForm('ruleForm') -->

    <newAuthorization
      ref="authorization"
      :treeMenus="treeMenus"
      @selectModules="selectModules"
      :propsKey="propsKey"
      name="groupName"
    />
  </div>
</template>
<script>
// TODO companyID没改，需要确认
import {
  regionData, CodeToText
} from "element-china-area-data";
import newAuthorization from "@/components/newAuthorization.vue";
import {
  Api_SuperAdmin,
  Api_Base,
  Api_System,
  Api_Company
} from "@/api/api";

import { getStore } from '@/util/store'
import { mapState } from 'vuex'

export default {
  components: {
    newAuthorization,
  },
  data() {
    return {
      treeMenus: [],
      options: regionData,
      totalCount: 0,
      currentPage: 1,
      pagesize: 10,
      projectTyle: -1,
      projectTypeList: [],
      selectedOptions: [],
      belongUnitList: [],
      getMoneyTypeList: [],
      unitTypeList: [],
      PlatList: [],
      searchKey: "",
      status: -1,
      authorizationShow: false,
      tableData: [],
      addDialogVisible: false,
      form: {
        projectName: '',
        address: "",
        projectArea: "",
        belongUnitName: "",
        authorityUnitTypeId: '', // 所属单位类型
        unitCode: "",// 社会统一信用代码
        permitCode: "", // 施工许可证号
        status: 1,
        userAccount: "",
        userPwd: "",
        projectLeader: "",
        projectLeaderPhone: "",
        authorityCompanyId: getStore({ name: 'companyId' }),
        templateId: "",
        templateProvinceId: "",
      },
      modalKey: 0,
      rules: {
        projectName: [{
          required: true,
          message: "请输入项目名称",
          trigger: "blur",
        },],
        authorityProjectTypeId: [{
          required: true,
          message: "请选择项目类型",
          trigger: "blur",
        },],
        projectArea: [{
          required: true,
          message: "请输入项目规模",
          trigger: "blur",
        },],
        belongUnitName: [{
          required: true,
          message: "请输入所属单位名称",
          trigger: "blur",
        },],
        address: [{
          required: true,
          message: "请输入项目所在地",
          trigger: "blur",
        },],
        authorityUnitTypeId: [{
          required: true,
          message: "请选择所属单位类型",
          trigger: "blur",
        },],
        unitCode: [{
          required: true,
          message: "请输入社会统一信用代码",
          trigger: "blur",
        },],
        // permitCode: [{
        //   required: true,
        //   message: "请输入施工许可证号",
        //   trigger: "blur",
        // },],
        userAccount: [{
          required: true,
          message: "请输入账号",
          trigger: "blur",
        },],
        userPwd: [{
          required: true,
          message: "请输入密码",
          trigger: "blur",
        },],
        templateId: [{
          required: true,
          message: "请选择模板",
          trigger: "blur",
        },],
        telephone: [
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
          {
            min: 11,
            max: 11,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
      companyId: getStore({ name: 'companyId' }),
      itemId: '',
      editId: 0,
      haveID: '',
      propsKey: [],
      projectId: getStore({ name: 'projectId' }),
      ProvinceMenusOption: []
    };
  },
  computed: {
    ...mapState(["companyInfo"]),
  },
  async created() {
    // console.log('this.====', this.companyInfo.companyName);
    this.form.belongUnitName = this.companyInfo.companyName
    this.getList();

    Api_Base.getMoneyTypeList().then((res) => {
      this.getMoneyTypeList = res.data.data;
    });

    Api_System.getPlatList().then((res) => {
      this.PlatList = res.data.data;
    });
    Api_System.getProjectType().then((res) => {
      this.projectTypeList = res.data.data;
    });
    Api_System.getUnitType().then((res) => {
      this.unitTypeList = res.data.data;
    });
    // await Api_SuperAdmin.allList().then((res) => {
    //   this.belongUnitList = res.data.data;
    //   this.belongUnitList = this.belongUnitList.filter(b => (this.companyId == b.id))
    //   this.form.belongUnitName = this.belongUnitList[0] && this.belongUnitList[0].companyName
    //   // this.form.authorityCompanyId = this.companyId
    // });
  },
  methods: {
    async handleChangeProvince(value) {
      this.form.templateId = ""
      let params = {
        provinceId: value,
        isOutProvince: 1
      }
      let res = await Api_Base.getProvinceMenus(params)
      let { statusCode, data } = res.data
      if (statusCode === 200) {
        this.ProvinceMenusOption = data
      }
    },
    openAdd() {
      this.addDialogVisible = true
      // this.form = {
      //   projectName: '',
      //   address: "",
      //   projectArea: "",
      //   // belongUnitName: "",
      //   authorityUnitTypeId: '', // 所属单位类型
      //   unitCode: "",// 社会统一信用代码
      //   permitCode: "", // 施工许可证号
      //   status: 1,
      //   userAccount: "",
      //   userPwd: "",
      //   projectLeader: "",
      //   projectLeaderPhone: "",
      //   authorityCompanyId: getStore({ name: 'companyId' })
      // }

      this.form = {
        projectName: '',
        address: "",
        projectArea: "",
        belongUnitName: this.companyInfo.companyName,
        authorityUnitTypeId: '', // 所属单位类型
        unitCode: "",// 社会统一信用代码
        permitCode: "", // 施工许可证号
        status: 1,
        userAccount: "",
        userPwd: "",
        projectLeader: "",
        projectLeaderPhone: "",
        authorityCompanyId: getStore({ name: 'companyId' }),
        templateId: "",
        templateProvinceId: "",
      }
    },
    // 获取公司所有菜单
    getModules(val) {
      this.companyId = val.authorityCompanyId;
      this.itemId = val.id
      console.log(val, "vallll");
      let params = {
        companyId: 0,
        projectId: val.id
      }
      Api_Company.getProjectTrees(params).then(res => {
        let data = res.data.data
        if (data) {
          data.forEach(el => {
            el.listTreeMenus.forEach(ell => {
              // ell.id = ell.menuId
              ell.groupName = ell.menuName
            })
          });
          this.treeMenus = data
          this.getMenuSelect(val.id)
        } else {
          this.$message({
            type: "error",
            message: "未设置权限!",
          });
        }
      })
    },
    getMenuSelect(id) {
      Api_SuperAdmin.getProjectSubSelect(id).then(res => {
        const result = res.data
        if (result.statusCode === 200) {
          this.propsKey = (result.data && result.data.authorityMenuId && result.data.authorityMenuId.split(',')) || []
          this.$refs.authorization.open()
        } else {
          this.propsKey = []
          this.$showMessage("失败", result.errors);
        }
      })
    },
    //选择模板
    getTemplate(val) {
      this.companyId = val.authorityCompanyId;
      this.itemId = val.id
      Api_SuperAdmin.modulesDetail(val.authorityCompanyId).then(res => {
        if (res.data.data && res.data.data.authorityMenuId) {
          this.haveID = res.data.data.authorityMenuId
          this.getMenuSelect(val.id)
        } else {
          this.$message({
            type: "error",
            message: "未设置权限!",
          });
        }
      })
    },

    selectModules(modules) {
      Api_SuperAdmin.setProjectModules({
        authorityCompanyId: this.companyId,
        authorityProjectId: this.itemId,
        authorityMenuId: modules.join(','),
      }).then(res => {
        this.$message({
          type: "success",
          message: "设置成功!",
        });
        this.authorizationShow = false
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.add();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.editId = 0;
      // this.addDialogVisible = false;
      // this.form = {
      //   platFormType: [],
      // };
    },
    edit(item) {
      this.editId = item.id
      Api_Company.projectDetail(item.id).then((res) => {
        let result = res.data;
        this.addDialogVisible = true;
        if (result.statusCode == 200) {
          item = res.data.data;
          this.handleChangeProvince(item.templateProvinceId)
          item.templateProvinceId = String(item.templateProvinceId)
          console.log(item);
          this.form = item;
          this.selectedOptions = [];
          this.selectedOptions.push(String(result.data.provinceId))
          this.selectedOptions.push(String(result.data.cityId))
          this.selectedOptions.push(String(result.data.areaId))
          this.form.selectedOptions = this.selectedOptions;
          this.form.authorityProjectTypeId = result.data.authorityProjectTypeId;
          this.modalKey++;
        }
      });
    },
    del(item) {
      this.$confirm("是否删除此项目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Api_Company.delProject(item.id).then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList();
        });
      });
    },
    add() {
      this.form.provinceId = this.form.selectedOptions[0];
      this.form.cityId = this.form.selectedOptions[1];
      this.form.areaId = this.form.selectedOptions[2];
      // this.form.platFormType = this.form.platFormType.join(",");

      // this.belongUnitList.map(item => {
      //   if (item.companyName === this.form.belongUnitName) {
      //     this.form.authorityCompanyId = item.id
      //   }
      // })

      if (this.form.id) {
        Api_Company.editProject(this.form).then((res) => {
          if (res.data.data) {
            this.$message({
              type: "success",
              message: "更新成功!",
            });
            this.addDialogVisible = false;
            this.form = {
              platFormType: [],
            };
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.data.errors,
            });
          }
        });
      } else {
        Api_Company.addProject(this.form).then((res) => {
          if (res.data.data) {
            this.$message({
              type: "success",
              message: "添加成功!",
            });
            this.addDialogVisible = false;
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.data.errors,
            });
          }
        });
      }
    },
    getList() {
      Api_Company.projectList({
        pageSize: this.pagesize,
        pageIndex: this.currentPage,
        authorityCompanyId: this.companyId,
        projectType: this.projectTyle,
        projectNam: this.searchKey,
        status: this.status,
      }).then((res) => {
        const { data: result } = res;
        if (result.statusCode == 200) {
          this.tableData = result.data.tList;
          this.totalCount = result.data.totalCount;
        }
      });
    },
    handleClose() {
      this.addDialogVisible = false;
      this.resetForm('ruleForm')
    },
    closeAuthor(val) {
      this.authorizationShow = val;
      this.propsKey = []
      this.companyId = ''
      this.haveID = ''
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
};
</script>